import apiAction from 'common/actions/api'

export const CHANGE_LOCATION = 'cylera/locations/CHANGE_LOCATION'

export const changeLocation = locationId => {
  return {
    type: CHANGE_LOCATION,
    location_id: locationId
  }
}

const locationsOverviewApi = apiAction('dashboard/locations')

export const getLocationsOverview = callback =>
  locationsOverviewApi('overview', {}, { success: callback })

const authApi = apiAction('auth')

export const partnerSwitch = (uuid, callback) =>
  authApi('partner_switch', { uuid }, { method: 'POST', success: callback })

export const partnerReset = callback =>
  authApi('partner_reset', {}, { method: 'POST' })

export const cyleraSwitch = (id, callback) =>
  authApi('cylera_switch', { id }, { method: 'POST', success: callback })
